import React, { useState, useEffect } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { useApp } from "../../contexts/AppContext";
import { ExpiryAlertsModal } from "../common/ExpiryAlertsModal";

export const AppLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showExpiryModal, setShowExpiryModal] = useState(false);
  const { notifications, isAdmin, expiringContracts } = useApp();

  useEffect(() => {
    if (!isAdmin || !expiringContracts?.length) return;

    const lastShownKey = "expiryModalLastShown";
    const lastShown = localStorage.getItem(lastShownKey);
    const now = Date.now();
    const oneDayMs = 24 * 60 * 60 * 1000;

    if (!lastShown || (now - parseInt(lastShown)) > oneDayMs) {
      setShowExpiryModal(true);
      localStorage.setItem(lastShownKey, now.toString());
    }
  }, [isAdmin, expiringContracts]);

  return (
    <div className="flex h-screen bg-gray-950 overflow-hidden">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarCollapsed(!sidebarCollapsed)} />
        <main className="flex-1 overflow-y-auto px-8 py-6 bg-gray-950">
          <div className="page-enter">{children}</div>
        </main>
      </div>

      {/* Notification toasts */}
      <div className="fixed bottom-6 right-6 flex flex-col gap-2 z-[9999]">
        {notifications.map(n => (
          <div
            key={n.id}
            className={`max-w-sm p-4 rounded-lg border text-sm font-medium shadow-lg animate-slideIn ${
              n.type === "error"
                ? "bg-red-950 border-red-700 text-red-200"
                : n.type === "success"
                ? "bg-green-950 border-green-700 text-green-200"
                : "bg-slate-900 border-slate-700 text-slate-200"
            }`}
          >
            {n.msg}
          </div>
        ))}
      </div>

      <style>{`@keyframes slideIn{from{opacity:0;transform:translateX(24px)}to{opacity:1;transform:translateX(0)}} .animate-slideIn{animation:slideIn 0.3s ease}`}</style>

      {showExpiryModal && expiringContracts?.length > 0 && (
        <ExpiryAlertsModal contracts={expiringContracts} onClose={() => setShowExpiryModal(false)} />
      )}
    </div>
  );
};
